import {Provider} from 'react-redux';

const StateProvider = props => <Provider store={polyphony.store} {...props} />;
StateProvider.displayName = 'StateProvider';

export default StateProvider;
